module.exports = __webpack_public_path__ + "img/dusty.038834cd.png";